import { useContext } from 'react'

import { WorkflowSurveysContext } from 'modules/surveys/lib/WorkflowSurveysContext'

export const useWorkflowSurveysContext = () => {
  const context = useContext(WorkflowSurveysContext)

  if (!context) {
    throw new Error('WorkflowSurveysContext must be within its provider')
  }

  return context
}
